import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"


import { useStore } from 'vuex';
import { DICOM2Date } from '../common/routines';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorklistDelete',
  props: ['selectedEntries'],
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props;



const store = useStore();

function closeCancel() {
    emits('close');
}

async function closeOk() {
    // Delete selected Studies.
    for (let i = 0; i < props.selectedEntries.length; i++) {
        const params = {
            id: props.selectedEntries[i].id,
            patid: props.selectedEntries[i].patid,
            patname: props.selectedEntries[i].patname
        };
        await store.dispatch("HTTPDelete", { url: "worklist/", id: params.id });
//        alert(result);
    }
    // Poner mensaje si hubo error o todo andubo bien.
    emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_modal_dialog = _resolveComponent("modal-dialog")!

  return (_openBlock(), _createBlock(_component_modal_dialog, {
    onCloseCancel: closeCancel,
    onCloseOk: closeOk,
    title: "Delete Worklist Entry",
    okBtn: "Delete",
    cnlBtn: "Cancel",
    style: {"width":"700px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("table", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.AccessionNumber")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.ID")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Name")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Date")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Modality")), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t("Study.Description")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectedEntries, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", null, _toDisplayString(item.id), 1),
              _createElementVNode("td", null, _toDisplayString(item.patid), 1),
              _createElementVNode("td", null, _toDisplayString(item.patname), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(DICOM2Date)(item.date)), 1),
              _createElementVNode("td", null, _toDisplayString(item.modality), 1),
              _createElementVNode("td", null, _toDisplayString(item.descr), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})